export default "__VITE_ASSET__DnPFW3Kz__"